import React, {useRef} from 'react';
import Swiper from 'react-id-swiper';
import '../assets/css/style.css'
import imagesPath from '../config/imagesPath';

const Testimonial = () => {
    const params = {
        loop: true,
        slidesPerView: 2,
        spaceBetween: 15,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        autoplay: {
            delay: 2000,
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 5
            },
            480: {
                slidesPerView: 1,
                spaceBetween: 5
            },
            992: {
                slidesPerView: 2,
                spaceBetween: 15
            }
        }
    }
    const swiperRef = useRef(null)
    return (
        <div>
            <section id="services" className="services">
                <div className="container" data-aos="fade-up">
                    <div className="section-titles">
                        <h3 className="heading_tow">TESTIMONIALS</h3>
                    </div>
                </div>
            </section>
            <section className="slider_loan">
                <div className="container" data-aos="fade-out">
                    <div className="cara_slider newAdditon"
                         onMouseEnter={() => swiperRef.current.swiper.autoplay.stop()}
                         onMouseLeave={() => swiperRef.current.swiper.autoplay.start()}>
                        <Swiper {...params}
                                ref={swiperRef}>
                            {
                                imagesPath.testmonialVideo.map((ele, index) => (
                                    <div className="swiper-slide" data-aos="zoom-in" data-aos-delay="100" key={index}>
                                        {ele.video1 && <div className="slider_pannel">
                                            <iframe height={250} className="testimonial-width" src={ele.video1}
                                                title="YouTube video player" frameBorder="0"
                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                allowFullScreen></iframe>
                                        </div>}
                                        {ele.video2 && <div className="slider_pannel mt-3" data-aos="zoom-in" data-aos-delay="200">
                                            <iframe height={250} className="testimonial-width" src={ele.video2}
                                                title="YouTube video player" frameBorder="0"
                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                allowFullScreen></iframe>
                                        </div>}
                                    </div>
                                ))
                            }
                        </Swiper>
                    </div>
                </div>
            </section>
        </div>

    );
};

export default Testimonial;



// WEBPACK FOOTER //
// ./src/components/Testimonial.js